import React from "react";
import { gql } from "@apollo/client";
import { MouthpieceDesign } from "@syos-music/instruments";
import { Product } from "@syos-music/products";

import { styled, Paper, Tooltip } from "@mui/material";
import {
  FormatText as TextIcon,
  Star as SignatureMouthpieceIcon,
  BilliardsRack as OriginalsIcon,
} from "mdi-material-ui";

const OriginalsType = Product.displayModes.originalsMouthpiece.OriginalsType;

const PreviewBox = styled(Paper)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

export default function SoundShapingDesign({ soundShaping, ...props }) {
  if (soundShaping.designType === "catalog")
    return (
      <Tooltip
        placement="top"
        title={<MouthpieceDesign design={soundShaping.designCatalog} />}
      >
        <PreviewBox {...props}>
          <MouthpieceDesign
            design={soundShaping.designCatalog}
            variant="image"
            sx={{ m: 0 }}
          />
        </PreviewBox>
      </Tooltip>
    );

  if (soundShaping.designType === "signature")
    return (
      <Tooltip placement="top" title={soundShaping.designSignature?.signature}>
        <PreviewBox {...props}>
          {soundShaping.designSignature?.metadata?.image?.url ? (
            <img src={soundShaping.designSignature.metadata.image.url} alt="" />
          ) : (
            <SignatureMouthpieceIcon />
          )}
        </PreviewBox>
      </Tooltip>
    );

  if (soundShaping.designType === "text")
    return (
      <Tooltip placement="top" title={soundShaping.designText}>
        <PreviewBox {...props}>
          <TextIcon />
        </PreviewBox>
      </Tooltip>
    );

  if (soundShaping.designType === "originals")
    return (
      <Tooltip
        placement="top"
        title={<OriginalsType originalsType={soundShaping.designOriginals} />}
      >
        <PreviewBox {...props}>
          <OriginalsIcon />
        </PreviewBox>
      </Tooltip>
    );

  return null;
}

SoundShapingDesign.fragments = {
  soundShaping: gql`
    fragment SoundShapingDesign_SoundShaping on SoundShaping {
      id
      designType

      designCatalog
      designText
      designSignature {
        id
        signature
        metadata {
          image {
            id
            url
          }
        }
      }
      designOriginals
    }
  `,
};
